import SystemIndex from "./Index";

const systemRoutes = [
    {
        path: "/core/system",
        element: <SystemIndex />,
    },
];

export default systemRoutes;
